"use client";

import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail, // Import pour réinitialisation de mot de passe
} from "firebase/auth"; 
import { auth } from "../firebase"; 
import CustomInput from "./Inputs/CustomInput";
import SubmitButton from "./Buttons/SubmitButton";

const LoginForm = () => {
  const navigate = useNavigate();
  const [isShowing, setIsShowing] = useState(false);
  const [resetSent, setResetSent] = useState(false); // État pour savoir si le reset a été envoyé
  const {
    register,
    handleSubmit,
    getValues, // Extraire getValues
    formState: { errors },
    setError,
  } = useForm();

  // Fonction de connexion avec Firebase
  const onSubmit = async (data) => {
    const { email, password } = data;

    try {
      // Connexion à Firebase avec email et mot de passe
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      console.log("User connecté :", userCredential.user);

      // Rediriger après connexion réussie
      navigate("/board");
    } catch (error) {
      console.error("Erreur de connexion :", error);

      // Gestion des erreurs : afficher un message si la connexion échoue
      setError("password", {
        type: "manual",
        message: "Email ou mot de passe incorrect",
      });
    }
  };

  // Fonction de réinitialisation du mot de passe
  const handleResetPassword = async () => {
    const email = getValues("email"); // Récupérer l'email saisi

    if (!email) {
      setError("email", {
        type: "manual",
        message: "Veuillez entrer votre adresse email",
      });
      return;
    }

    try {
      // Envoyer l'email de réinitialisation
      await sendPasswordResetEmail(auth, email);
      setResetSent(true);
      setTimeout(() => setResetSent(false), 5000); // Cache le message après 5 secondes
    } catch (error) {
      console.error("Erreur de réinitialisation du mot de passe :", error);
      setError("email", {
        type: "manual",
        message: "Erreur lors de l'envoi de l'email de réinitialisation",
      });
    }
  };

  return (
    <div className="w-full space-y-4">
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* Email Input */}
        <CustomInput
          label={"Email"}
          id={"email"}
          type="email"
          register={register}
          errors={errors}
          placeholder="Email"
          validation={{
            pattern: {
              value: /^[^@]+@[^@]+\.[^@]+$/,
              message: "Veuillez entrer un email valide",
            },
          }}
        />
        {/* Mot de passe Input */}
        <div>
          <label htmlFor="password" className="block text-sm font-medium mb-2">
            Mot de passe
          </label>
          <div className="relative">
            <input
              type={isShowing ? "text" : "password"}
              id="password"
              {...register("password", {
                required: "Le mot de passe est obligatoire",
              })}
              className={`py-3 px-4 block w-full border ${
                errors.password ? "border-red-500" : "border-gray-300"
              } rounded-lg text-sm focus:border-${
                errors.password ? "red" : "gray"
              }-500 focus:ring-${errors.password ? "red" : "gray"}-500`}
              aria-describedby="password-helper"
              placeholder="Mot de passe"
            />
            <div className="absolute inset-y-0 end-0 flex items-center pointer-events-none pe-3">
              {errors.password ? (
                <svg
                  className="shrink-0 size-4 text-red-500"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" x2="12" y1="8" y2="12"></line>
                  <line x1="12" x2="12.01" y1="16" y2="16"></line>
                </svg>
              ) : null}
            </div>
          </div>
          <p className="text-sm text-red-600 mt-2" id="password-helper">
            {errors.password ? errors.password.message : ""}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 10,
            gap: 5,
          }}
        >
          <input
            type="checkbox"
            onClick={() => setIsShowing(!isShowing)}
          ></input>
          <label htmlFor="password" className="block text-sm font-medium">
            {isShowing ? "Cacher le mot de passe" : "Voir le mot de passe"}
          </label>
        </div>

        {/* Mot de passe oublié */}
        <div className="flex justify-end">
          <button
            type="button"
            onClick={handleResetPassword}
            className="text-sm text-blue-500 hover:underline"
          >
            Mot de passe oublié ?
          </button>
        </div>
        {resetSent && (
          <p className="text-green-500 text-sm">
            Email de réinitialisation envoyé avec succès !
          </p>
        )}

        {/* Submit Button */}
        <SubmitButton label={"Se connecter"} />
      </form>
    </div>
  );
};

export default LoginForm;
